import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
  setup() {
    const store = useStore();
    let cartNo = computed(() => {
      store.commit("countCart");
      return store.state.totalNum;
    });
    //console.log("cartList",cartList)
    return {
      cartNo
    };
  }
};